module.exports = __webpack_public_path__ + "static/media/cabin.05ee9055.jpg";